import { Typography, styled } from '@mui/material'
import React, { ReactNode } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { colors } from '../../../../Theme/LegacyTheme'
import Link from 'next/link'

interface FooterColumnProps {
  title: string
  links: {
    text: string
    url: string
  }[]
  children?: ReactNode
}

const FooterCol = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flexBasis: '50%',
  paddingRight: theme.spacing(2),
  [theme.breakpoints.up('md')]: {
    flexBasis: '25%',
    paddingRight: theme.spacing(4)
  },
  ul: {
    padding: `0 ${theme.spacing(2)} 0 0`,
    marginTop: 0,
    marginBottom: 0,
    li: {
      listStyle: 'none',
      padding: `${theme.spacing(2)} 0`,
      a: {
        textDecoration: 'none',
        color: colors.black
      }
    }
  }
}))

const FooterColumn: React.FC<FooterColumnProps> = ({ title, links, children }) => {
  return (
    <FooterCol>
      <Typography variant="subHeading">{title}</Typography>
      <ul>
        {links.map((link) => (
          <li key={uuidv4()}>
            <Link href={link.url} role="link">
              {link.text}
            </Link>
          </li>
        ))}
      </ul>
      {children}
    </FooterCol>
  )
}

export default FooterColumn
